whenAvailable('$', function() {
$(function () {
    // SOCIAL MEDIA
    $('#sel_socialmedia').on('change', function() {
        switch (this.value) {
            case 'naver':
                $('#link_to_post').attr("placeholder", "e.g. https://blog.naver.com/secretlabkr/222029514659");
                $('#modal_selector').show().attr('data-socialtype', 'naver');
                $('#link_format').text('Naver');
                break;
            case 'facebook':
                $('#link_to_post').attr("placeholder", "e.g. https://www.facebook.com/photo.php?fbid=10155929555839121");
                $('#modal_selector').show().attr('data-socialtype', 'facebook');
                $('#link_format').text('Facebook');
                break;
            case 'instagram':
                $('#link_to_post').attr("placeholder", "e.g. https://www.instagram.com/p/h23YH3wj23f");
                $('#modal_selector').show().attr('data-socialtype', 'instagram');
                $('#link_format').text('Instagram');
                break;
            case 'twitter':
                $('#link_to_post').attr("placeholder", "e.g. https://x.com/username/status/1236582790234234658");
                $('#modal_selector').show().attr('data-socialtype', 'twitter');
                $('#link_format').text('X');
                break;
            case 'twitch':
                $('#link_to_post').attr("placeholder", "e.g. https://clips.twitch.tv/JohnSmithAndHisSecretlabChair");
                $('#modal_selector').show().attr('data-socialtype', 'twitch');
                $('#link_format').text('Twitch');
                break;
            case 'youtube':
                $('#link_to_post').attr("placeholder", "e.g. https://youtu.be/45Ku0vfCHtc?t=10");
                $('#modal_selector').show().attr('data-socialtype', 'youtube');
                $('#link_format').text('Youtube');
                break;
            case 'reddit':
                $('#link_to_post').attr("placeholder", "e.g. https://www.reddit.com/r/JohnSmithAndHisSecretlabChair");
                $('#modal_selector').show().attr('data-socialtype', 'reddit');
                $('#link_format').text('Reddit');
                break;
            case 'tiktok':
                $('#link_to_post').attr("placeholder", "e.g. https://vt.tiktok.com/ZS8Mvu3kQ/");
                $('#modal_selector').show().attr('data-socialtype', 'tiktok');
                $('#link_format').text('TikTok');
                break;
            default:
                $('#link_to_post').attr("placeholder", "Social media public post/video link");
                $('#modal_selector').hide();
                $('#link_format').text('');
        }
    });
    // MODAL
    $('#modal_socialmedia').on('show.bs.modal', function (e) {
        const type = $(e.relatedTarget).attr('data-socialtype');
        $('.modal-content-media').hide();
        $('#modal-content-' + type).show();

        if (type === 'youtube') {
            $('.title-platform').text('YouTube');
        } else if (type === 'naver') {
            if (shop_locale == 'en') {
                $('.title-platform').text('Naver Blog');
            } else {
                $('.title-platform').text('Naver 블로그');
            }
        } else if (type === 'twitter') {
            $('.title-platform').text('X');
        } else {
            $('.title-platform').text(type);
        }
    })
    // PLACE OF PURCHASE
    $('#sel_place_of_purchase').change(function () {
        $('input.form-control').val('').removeClass('is-valid').removeClass('is-invalid');
        $('#shopify_order_id, #order_no').val('');
        $('#order_valid, #url_valid').val(0);
        var pop = $('#sel_place_of_purchase :selected').val();
        $('#place_of_purchase').val(pop);
        $('#is_marketplace').val($('#sel_place_of_purchase :selected').attr('data-marketplace'));

        update_link_shopify_content( $('#sel_place_of_purchase :selected').attr('data-link-shopify') );

        if ('N' === $('#sel_place_of_purchase :selected').attr('data-link-shopify')) {
            $('#store_code').val($('#sel_place_of_purchase :selected').attr('data-country'));
        } else {
            $('#store_code').val($('#store_code').data('original-country'));
        }

        $('#order_number').attr('placeholder', '');

        if ('N' === $('#sel_place_of_purchase :selected').attr('data-marketplace')) {
            $('#order_number').attr('placeholder', $('#order_number').data('secretlab'));
            $('#order_rule_2').show();
        } else {
            $('#order_rule_2').hide();
            switch (pop) {
                case 'amazon':
                    $('#order_number').attr('placeholder', 'e.g. 114-0000000-0000000');
                    break;
                case 'lazada':
                    $('#order_number').attr('placeholder', 'e.g. 9200000000000');
                    break;
                case 'tiktok':
                    $('#order_number').attr('placeholder', 'e.g. 000000000000000000');
                    break;
                case 'shopee':
                    $('#order_number').attr('placeholder', 'e.g. 0000000000XXXX');
                    break;
                case 'newegg':
                    $('#order_number').attr('placeholder', 'e.g. 440000000');
                    break;
                case 'tokopedia':
                    $('#order_number').attr('placeholder', 'e.g. 440000000');
                    break;
                case 'blibli':
                    $('#order_number').attr('placeholder', 'e.g. 10000000000-10000000000');
                    break;
                case 'jdid':
                    $('#order_number').attr('placeholder', 'e.g. 1000000000');
                    break;
                case 'naver':
                    $('#order_number').attr('placeholder', 'e.g. 2000000000000000');
                    break;
                case 'inven':
                    $('#order_number').attr('placeholder', 'e.g. 1000000000000000');
                    break;
                case 'youtube-T1':
                    $('#order_number').attr('placeholder', 'e.g. 20201231-0000001');
                    break;
                case 'commart':
                    $('#order_number').attr('placeholder', 'e.g. LXR20240000000');
                    break;
                default:
                    $('#order_number').attr('placeholder', '');
                    break;
            }
        }
        $('#main_form').slideDown();
    });
    // KR checkbox
    if ($('.terms-kr').length > 0) {
        let checkboxTarget = '.terms-kr .field.stack';
        $(checkboxTarget).change(function() {
            if ($(this).hasClass('all')) {
                if ($(checkboxTarget + '.all .input-checkbox')[0].checked) { $(checkboxTarget + '.single .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.single .input-checkbox').prop('checked', false); }
            } else {
                var allChecked = true;
                $(checkboxTarget + '.single .input-checkbox').each(function(i,v) { if (!this.checked) { allChecked = false; } });
                if (allChecked == true) { $(checkboxTarget + '.all .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.all .input-checkbox').prop('checked', false); }
            }
        });
    }

    // UPDATE link_to_shopify AND TOGGLE PROOF OF PURCHASE
    function update_link_shopify_content(show_content) {
        show_content = (show_content == 'Y' || show_content == true) ? 'Y' : 'N';

        $('#link_to_shopify').val(show_content);
        if (show_content === 'N') {
            $('#wrapper_proof_of_purchase').prop('required', true).show();
            $('#proof_of_purchase').prop('disabled', false);
            $('#need_proof').val(1);
            $('#form_field_index').text('6');
        } else {
            $('#wrapper_proof_of_purchase').prop('required', false).hide();
            $('#proof_of_purchase').prop('disabled', true);
            $('#need_proof').val(0);
            $('#form_field_index').text('5');
        }
    }

    // ORDER NUMBER CHANGE
    function is_valid_order_no(number, type) {
        switch (type) {
            case 'amazon':
                // 114-6482380-1689059
                // 111-0883526-3140250
                // 103-4795772-1364518
                return /^[0-9]{3}-[0-9]{7}-[0-9]{7}$/g.test(number);
            case 'blibli':
                // 10000000000-10000000000
                return /^[0-9]{11}(-[0-9]{11})?$/g.test(number);
            case 'jdid':
                // 1000000000
                return /^[0-9]{10}$/g.test(number);
            case 'newegg':
                // 450252014
                // 311286584
                return /^[0-9]{9}$/g.test(number);
            case 'tokopedia':
                // 450252014
                // 3112865844
                return /^[0-9]{9,10}$/g.test(number);
            case 'lazada':
                // 20415081808099
                return /^[0-9]{14,16}$/g.test(number);
            case 'tiktok':
                // 123456789123456789
                return /^[0-9]{18}$/g.test(number);
            case 'shopee':
                // 19082318341WCMC
                // 19082300021DDTW
                // 19080912391U6R3
                // 19061821021QKEJ
                return /^[0-9]{6}[0-9A-Z]{8,9}$/g.test(number);
            case 'commart':
                // LXR2024
                return /^[A-Z]{3}[0-9]{4}[0-9]{7}$/g.test(number);
            case 'naver':
            case 'inven':
                // 1234567890123456
                return /^[0-9]{16}$/g.test(number);
            case 'youtube-T1':
                return /^(20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])-\d{6}$/g.test(number);
            default:
                return false;
        }
    }
    
    $('#order_number').on('blur', function () {
        
        $(this).removeClass('is-valid, is-invalid');

        var order_no     = $(this).val(),
            country_code = $('#store_code').val(),
            link_shopify = $('#sel_place_of_purchase option:selected').attr('data-link-shopify'),
            store_type   = $('#place_of_purchase').val();

        if ('Y' === link_shopify) {
            $.post('https://beans.secretlab.co/index.php/api/2019-08/'+shop_locale+'/verify_order_no/', {
                order_no:     order_no,
                country_code: country_code,
                link_shopify: link_shopify,
                store_type:   store_type
            }, function (data) {
                if ('ok' === data.status) {
                    $('#shopify_order_id').val(data.shopify_order_id);
                    $('#order_no').val(data.secretlab_order_no);
                    $('#marketplace_order_number').val(data.marketplace_order_no);
                    $('#order_valid').val(1);
                    $('#order_number').removeClass('is-invalid');
                    $('#order_number').get(0).setCustomValidity('');
                    update_link_shopify_content(true);
                    return;
                }

                // If amz order_no not found, default to link_shopify == 'N'
                if ('not_found' === data.status && 'amazon' === store_type && is_valid_order_no(order_no, store_type)) {
                    $('#order_number').removeClass('is-invalid');
                    $('#order_number').get(0).setCustomValidity('');
                    $('#order_valid').val(1);
                    $('#marketplace_order_number').val(order_no);
                    update_link_shopify_content(false);
                    return;
                }

                // Invalid Order Number
                $('#order_valid').val(0);
                $('#order_number').addClass('is-invalid');
                $('#order_number').get(0).setCustomValidity('Please provide a valid order number.');
            }, 'json');
            return;
        }

        if (is_valid_order_no(order_no, store_type)) {
            $('#order_number').removeClass('is-invalid');
            $('#order_number').get(0).setCustomValidity('');
            $('#order_valid').val(1);
            $('#marketplace_order_number').val(order_no);
            return;
        }

        // Invalid Order Number
        $('#order_number').addClass('is-invalid');
        $('#order_number').get(0).setCustomValidity('Please provide a valid order number.');
        $('#order_valid').val(0);
    });


    function is_url_valid (url) {
        let test = false;
        const format = $('#modal_selector').attr('data-socialtype');

        if (/^https:\/\/(www\.|m\.)?facebook.com\/[a-zA-Z0-9-_.=\/?&]+/g.test(url) && format === 'facebook') {
            test = true;
        } else if (/^https:\/\/(www\.)?instagram.com\/(p|tv|reel)\/[a-zA-Z0-9-_]+(\/)*(\?igshid=[a-z0-9]+)*/g.test(url) && format === 'instagram') {
            // Sample Instagram Reel link: https://www.instagram.com/reel/CnCuKEajly7/?igshid=NTdlMDg3MTY=
            test = true;
        } else if (/^https:\/\/(www\.)?(twitter|x).com\/[A-Za-z0-9_]+\/status\/[0-9]+/g.test(url) && format === 'twitter') {
            test = true;
        } else if (/^(https|http):\/\/(www\.)?(youtube.com\/watch\?v=\w*|youtu.be\/\w*)((&|\?)t=\d+)?/g.test(url) && format === 'youtube') {
            test = true;
        } else if (/^(https|http):\/\/(www\.)?youtube.com\/shorts\/[a-zA-Z0-9-_.]+(\?feature=[a-z0-9]+)*/g.test(url) && format === 'youtube') {
            // Sample Youtube Shorts link: https://youtube.com/shorts/VoT9ZlZUhcU?feature=share
            test = true;
        } else if (/^https:\/\/(www\.)?reddit.com\/r\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'reddit') {
            test = true;
        } else if (/^https:\/\/(www\.)?reddit.com\/user\/[a-zA-Z0-9-_\/]{3,20}\/comments\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'reddit') {
            test = true;
        } else if (/^https:\/\/(www\.)?twitch.tv\/[a-zA-Z0-9-_\/]{4,25}\/clip\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'twitch') {
            test = true;
        } else if (/^https:\/\/clips\.?twitch.tv\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'twitch') {
            test = true;
        } else if (/^https:\/\/vt\.?tiktok.com\/[a-zA-Z0-9-_\/]+/g.test(url) && format === 'tiktok') {
            // Sample mobile link: https://vt.tiktok.com/ZS8Mvu3kQ/
            test = true;
        } else if (/^https:\/\/www\.?tiktok.com\/[@a-zA-Z0-9-_.]+\/video\/[0-9]+/g.test(url) && format === 'tiktok') {
            // Sample desktop link: https://www.tiktok.com/@user.name/video/7184719262173383938
            test = true;
        } else if (/^https:\/\/blog\.?naver.com\/[a-zA-Z0-9-_\/]{3,20}\/[0-9]+/g.test(url) && format === 'naver') {
            test = true;
        }

        return test;
    }


    $('#link_to_post').change(function () {
        $(this).removeClass('is-valid').removeClass('is-invalid');
        var link = $(this).val();
        if (is_url_valid(link)) {
            $('#link_to_post').removeClass('is-invalid');
            $('#link_to_post').get(0).setCustomValidity('');
            $('#url_valid').val(1);
        } else {
            $('#link_to_post').addClass('is-invalid');
            $('#link_to_post').get(0).setCustomValidity('Please provide a valid URL.');
            $('#url_valid').val(0);
        }
    });

    $('#redeem_submit').on('click', function(){ $.validateForm('#redeem_form'); });
    $('#redeem_form').submit(function (e) {
        e.preventDefault();
        //reset all msg to hide
        hideAllMsg();
        //disable button while request is processing
        $('#redeem_submit').prop('disabled', true);
        $('#i_agree').prop('disabled', true);

        let $recaptchaFeedback = $('.g-recaptcha + .invalid-feedback');

        $recaptchaFeedback.hide();

        if (grecaptcha.getResponse().length == 0) {
            if ($recaptchaFeedback.length > 0) {
                $recaptchaFeedback.show();
            } else {
                alert('Please click the reCAPTCHA checkbox.');
            }
            $('#redeem_submit').prop('disabled', false);
            $('#i_agree').prop('disabled', false);
            return false;
        }

        // using ajax instead of normal form submit
        $.ajax({
            type: "POST",
            enctype: 'multipart/form-data',
            url: "https://beans.secretlab.co/index.php/api/2019-08/"+ shop_locale +"/redeem_submission/",
            data: new FormData(this),
            processData: false,
            contentType: false,
            cache: false,
            timeout: 60000,
            dataType: "json",
        }).done(function(data){
            if (!data) {
                showErrDefault();
                return;
            }
            if(!data.error){
                showOK();
                return;
            }

            if(data.payload == "error-dup"){
                showErrDup();
                return;
            }

            if(data.payload == "error-pending"){
                showErrPending();
                return;
            }
            if(data.payload == "error-approved"){
                showErrAlreadyApproved();
                return;
            }
            //show default error message if we get to this part
            showErrDefault();
        }).fail(function(response){
            showErrDefault();
            console.log("ERROR: ", response.responseText);
            if ( typeof Sentry != 'undefined' ) {
                Sentry.captureException(new Error('[SLE] Error occurred on form [#redeemForm], '+ response.statusText + ': ' + response.responseText));
            }
        }).then(function(){
            $('#redeem_submit').prop('disabled', false);
            $('#i_agree').prop('disabled', false);
            grecaptcha.reset(); // reset recaptcha
        });
    });
    var hash = window.location.hash;
    if ('#ok' == hash) {
        showOK();
    } else if ('#error-dup' == hash) {
        showErrDup();
    } else if ('#error-pending' == hash) {
        showErrPending();
    } else if ('#error-approved' == hash) {
        showErrAlreadyApproved();
    } else if (hash.indexOf('error') !== -1) {
        showErrDefault();
    }

    /**
     * FUNCTIONS HERE ARE FOR DISPLAYING ERROR CODES
     */
    function showOK(){
        $('#res_ok').removeClass('d-none');
        $('html, body').animate({ scrollTop: $("#redeem_form").offset().top }, 1000);
    }

    function showErrDup(){
        // error if social media link already used
        $('#res_duplicate').removeClass('d-none');
        $('html, body').animate({ scrollTop: $("#redeem_form").offset().top }, 1000);
    }

    function showErrPending(){
        // error if previous request is pending approval
        $('#res_pending').removeClass('d-none');
        $('html, body').animate({ scrollTop: $("#redeem_form").offset().top }, 1000);
    }

    function showErrAlreadyApproved() {
        // error if previous request is already approved
        $('#res_approved').removeClass('d-none');
        $('html, body').animate({ scrollTop: $("#redeem_form").offset().top }, 1000);
    }

    function showErrDefault() {
        // default error if request failed
        $('#res_fail').removeClass('d-none');
        $('html, body').animate({ scrollTop: $("#redeem_form").offset().top }, 1000);
    }

    function hideAllMsg() {
        $('#res_ok').addClass('d-none');
        $('#res_duplicate').addClass('d-none');
        $('#res_pending').addClass('d-none');
        $('#res_approved').addClass('d-none');
        $('#res_fail').addClass('d-none')
    }
});
});
